
// SVG Icon: help-2
export default { id: "terriajs-help-2" };
export const id = "terriajs-help-2";
export const name = "help-2";
